// eslint-disable-next-line import/prefer-default-export
export const TYPES = {
  COVID_19: 'COVID_19',
  GENERIC: 'GENERIC',
};
